import React from "react";
import AccordionItem from "./AccordionItem";
import { mergeStyles } from "../../utils/utilStyles";

const accordionStyle = {
  header: {
    open: {
      backgroundColor: "bg-ov-gray",
    },
  },
  body: {
    backgroundColor: "bg-white",
  },
};

const Accordion = ({
  id,
  data,
  headerChildren,
  bodyChildren,
  activeIndexes,
  setActiveIndexes,
  singleActive = true,
  bodyOverflow = "",
  itemId = "",
  overrideStyle = {},
}) => {
  const handleClick = (index) => {
    if (singleActive) {
      if (activeIndexes.includes(index)) {
        setActiveIndexes([]);
      } else {
        setActiveIndexes([index]);
      }
    } else {
      const newIndexes = activeIndexes.includes(index)
        ? activeIndexes.filter((i) => i !== index)
        : [...activeIndexes, index];
      setActiveIndexes(newIndexes);
    }
  };

  return (
    <div id={id} className="flex flex-col divide-slate-200 overflow-visible">
      {data?.map((item, index) => (
        <AccordionItem
          key={index}
          id={itemId.replace("{index}", index)}
          index={index}
          item={item}
          isActive={activeIndexes.includes(index)}
          onClick={() => handleClick(index)}
          headerChildren={headerChildren}
          bodyChildren={bodyChildren}
          bodyOverflow={bodyOverflow}
          overrideStyle={mergeStyles(accordionStyle, overrideStyle)}
        />
      ))}
    </div>
  );
};

export default Accordion;
